import { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormik, FormikProvider } from 'formik'

import agent from 'agent'
import toast from 'lib/toast'
import Button from 'components/common/Button'
import Schedule from 'components/scenarios/detail/schedule/Schedule'
import theme from 'theme'
import { messageFromResponseError } from 'utils/strings'
import useAuth from 'hooks/use-auth'

export default function ScheduleWrapper({
  schedule,
  scenarioId,
  setScheduleOffCanvas,
  fetchScenario
}) {
  const { currentTeamId } = useAuth()
  const [isSaving, setIsSaving] = useState(false)

  const form = useFormik({
    initialValues: {
      isScheduleEnabled: schedule?.enabled ?? true,
      start: schedule?.trigger?.start ?? '',
      end: schedule?.trigger?.end ?? '',
      maxRuns: schedule?.trigger?.maxRuns ?? 1,
      activeDays: schedule?.trigger?.activeDays ?? []
    },
    validateOnChange: true
  })

  return (
    <FormikProvider value={form}>
      <Schedule expanded={true} />
      <Button
        data-test-save-schedule
        disabled={isSaving}
        onClick={async () => {
          setIsSaving(true)
          const {
            activeDays,
            start,
            end,
            maxRuns,
            isScheduleEnabled
          } = form.values
          try {
            await agent[schedule ? 'put' : 'post'](
              schedule
                ? `/schedules/scenarios/${schedule.guid}?teamId=${currentTeamId}`
                : `/schedules/scenarios?teamId=${currentTeamId}`,
              {
                scenario_id: scenarioId,
                trigger: {
                  type: 'Random',
                  activeDays,
                  start,
                  end,
                  maxRuns,
                  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                enabled: isScheduleEnabled
              }
            )
            await fetchScenario()
            toast({
              type: 'success',
              text: `Schedule ${schedule ? 'updated' : 'created'} successfully`
            })

            setScheduleOffCanvas(false)
          } catch (err) {
            toast({
              type: 'error',
              text: messageFromResponseError(
                err,
                'There was an issue scheduling this scenario. Please try again later.'
              )
            })
          } finally {
            setIsSaving(false)
          }
        }}
      >
        Save schedule
      </Button>
      <Button
        secondary
        css={{ marginLeft: theme.space[2] }}
        onClick={() => setScheduleOffCanvas(false)}
      >
        Cancel
      </Button>
    </FormikProvider>
  )
}

ScheduleWrapper.propTypes = {
  schedule: PropTypes.object,
  scenarioId: PropTypes.string,
  setScheduleOffCanvas: PropTypes.func,
  fetchScenario: PropTypes.func
}
